import React from 'react';
import logo from '../mlogo2.png';
import '../App.css';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <br/>
        <img src={logo} style={{width:"300px"}} className="App-mlogo" alt="logo" />

        <h2>
          Mladen Milesic
        </h2>
        <a
          className="App-link"
          href="https://github.com/mledan/"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <a
          className="App-link"
          href="https://www.linkedin.com/in/mladenmilesic/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <Link to="/resume" className="App-link">Résumé</Link>
        <Link to="/uses" className="App-link">Uses</Link>
      </header>
      <footer id="footer">
        <Link to="/admin" className="App-link">Login</Link>
      
      </footer>
    </div>
   
  );
}

export default Home;
